module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 84
// module chunks = 0